export default __webpack_public_path__ + "static/media/companyLogo1.d1354f8a.png";